import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { getFramesDisplayPrice } from '../utils/get-frames-display-price.js';
import { useProductDetailQueryParams } from '../../../../hooks/use-product-detail-query-params.js';
import { getSelectedOffering } from '../../utils/get-selected-offering.js';
import { ChannelAvailability } from '../../../../types/product.js';
import { useProductData } from '../../../../context/product-context-hooks.js';

const FramesEcommContext = /*#__PURE__*/ React.createContext({});
const useFramesEcommContext = ()=>React.useContext(FramesEcommContext)
;
const FramesEcommProvider = ({ children  })=>{
    var ref;
    const { activeVariant: { channelAvailability , price , sku  } , product ,  } = useProductData();
    const { isPrescriptionGlassesEnabled  } = useFeatureToggles();
    const [isConfiguratorOpen, setIsConfiguratorOpen] = React.useState(false);
    const handleConfiguratorOpen = ()=>{
        setIsConfiguratorOpen(true);
    };
    const handleConfiguratorClose = ()=>{
        setIsConfiguratorOpen(false);
    };
    const { filteredOfferings , isReimbursable  } = useProductDetailQueryParams();
    const offerings = (ref = product.offerings) === null || ref === void 0 ? void 0 : ref.filter((offering)=>isReimbursable ? offering.isInsuranceReimbursable : !offering.isInsuranceReimbursable
    );
    const [selectedOffering, setSelectedOffering] = React.useState(getSelectedOffering(offerings, filteredOfferings));
    const [sspTotalPrice, setSspTotalPrice] = React.useState();
    const displayPrice = getFramesDisplayPrice(price, selectedOffering, !isPrescriptionGlassesEnabled ? sspTotalPrice : undefined);
    const productAction = React.useMemo(()=>{
        const fallbackAction = channelAvailability === ChannelAvailability.ONLINE && isPrescriptionGlassesEnabled ? 'OPEN_CONFIGURATOR' : 'OPEN_CONFIGURATOR_UNAVAILABLE';
        const variantAction = selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.actions.find((action)=>action.variantSku === sku
        );
        return variantAction ? variantAction.action : fallbackAction;
    }, [
        isPrescriptionGlassesEnabled,
        channelAvailability,
        selectedOffering,
        sku
    ]);
    const value = {
        productAction,
        isConfiguratorOpen,
        handleConfiguratorOpen,
        handleConfiguratorClose,
        offerings,
        selectedOffering,
        setSelectedOffering,
        displayPrice,
        setSspTotalPrice
    };
    return /*#__PURE__*/ React.createElement(FramesEcommContext.Provider, {
        value: value
    }, children);
};

export { FramesEcommContext, FramesEcommProvider, useFramesEcommContext };
//# sourceMappingURL=FramesEcommContext.js.map
